const breakpointNames = ["sm", "md", "lg", "xl"]

const makeBackgroundImageArray = imageFolderName => nameOfPage =>
  breakpointNames.map(
    breakpoint => `url("/${imageFolderName}/${nameOfPage}/${breakpoint}.png")`
  )

export default makeBackgroundImageArray("images")
